module.exports = __webpack_public_path__ + "components/rewards/hourly/static/logo-4f06b2a49bf578d77d222241eb14e962.jpg";